import errorManager from '@/rollbar.js';

const calc = (gravita, probabilita) => {
  const probabilita_option = probabilita.options[probabilita.selectedIndex];
  const gravita_option = gravita.options[gravita.selectedIndex];
  const result_element = document.getElementById('ipr_value'),
    gravita_val = gravita_option.getAttribute('cod') * 1,
    probabilita_val = probabilita_option.getAttribute('cod') * 1;
  result_element.innerHTML = 0;
  if (isNaN(probabilita_val) || isNaN(gravita_val)) return;

  result_element.innerHTML = probabilita_val * gravita_val;
};

const hide_data = (e) => {
  const el = $(e.target);
  const val = el.find(':selected');
  const cod = val.attr('cod');
  const farmacia = document.querySelector('.farmacia');
  if (cod == 'farmacia') {
    farmacia.style.display = 'none';
  } else {
    farmacia.style.display = 'block';
  }
};

const setListener = (eventSelector, dateEventSelector, dateEndSelector, durationEnabled, businessUnitId, getDurationUrl, function_name) => {
  const gravita = document.getElementById('gravita');
  const probabilita = document.getElementById('probabilita');
  $('#gravita, #probabilita').on('change', () => calc(gravita, probabilita));
  $('#eventi').on('change', (e) => hide_data(e));
};

const init = () => {
  try {
    setListener();
  } catch (e) {
    errorManager(e);
  }
};

window.CalcIPR = {
  init: init,
};
